import { render } from "./SoapberryGamePage.vue?vue&type=template&id=16a3a8d0&scoped=true"
import script from "./SoapberryGamePage.vue?vue&type=script&lang=js"
export * from "./SoapberryGamePage.vue?vue&type=script&lang=js"

import "./SoapberryGamePage.vue?vue&type=style&index=0&id=16a3a8d0&scoped=true&lang=css"
import "./SoapberryGamePage.vue?vue&type=style&index=1&id=16a3a8d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a3a8d0"]])

export default __exports__